function initializeEnvBar() {
  const envBar = document.getElementById("jsEnvBar");

  if (envBar) {
    const btn = document.getElementById("jsDisableEnvBar");
    document.querySelector("html").classList.add("isShowEnvBar");
    envBar.style.display = "block";
    btn.addEventListener("click", () => {
      envBar.style.display = "none";
      document.querySelector("html").classList.remove("isShowEnvBar");
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initializeEnvBar();
});

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeEnvBar;